import Icon from "../../../../assets/icons/Icon";
import { useEffect, useState } from "react";
import { selectInventoryTransactionType } from "../../../../redux/slices/transactionTypeSlice";
import { useSelector } from "react-redux";
import CustomTable from "../../../controls/CustomTable";
import Pagination from "../../../controls/Pagination";
import { fetchTransactionInventoryApi } from "../../../../api/ViewproductApi";
import { toast } from "react-toastify";
import Loading from "../../../controls/Loading";
import { isMobileView } from "../../../controls/CommonFunctions";

const ProductInventorytransaction = ({ productData }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [showFilterOptions, setShowFilterOptions] = useState(false);
    const inventoryTransactionType = useSelector(selectInventoryTransactionType);
    const [filterOptions, setFilterOptions] = useState([]);
    const [filteredSelectedValue, setFilteredSelectedValue] = useState('All'); // Default selected value as 'All'
    const [filterSelectedTransactionId, setFilterSelectedTransactionId] = useState(''); // Default selected filter ID as ''
    const [tableData, setTableData] = useState([]); // Ensure it's an array
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [from, setFrom] = useState(0);
    const [size, setSize] = useState(25);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);
    const newField = {
        TransactionType: 'All',
        key: ''
    };

    useEffect(() => {
        // Ensure productData and inventoryTransactionType are correctly available
        console.log("inventoryTransactionType", inventoryTransactionType);

        if (inventoryTransactionType.length > 0) {
            setFilterOptions([newField, ...inventoryTransactionType]); // Prepend 'All' option
            setFilteredSelectedValue(newField.TransactionType);  // Set default as 'All'
            setFilterSelectedTransactionId(newField.key);  // Set default key as ''
        }
    }, [inventoryTransactionType]); // Run when inventoryTransactionType changes

    useEffect(() => {
        // Fetch data on first load or when the selected filter changes
        fetchData(productData.key, filterSelectedTransactionId); 
    }, [productData.key, filterSelectedTransactionId, from, size]); // Run on component mount and filter change

    const fetchData = async (productId, transactionId) => {
        setLoading(true);
        try {
            const data = await fetchTransactionInventoryApi(
                from, // From
                size, // Size
                productId, // Use productData.key
                transactionId || '', // Use the selected transaction type ID (empty for 'All')
                '' // Optional: You can use transactionNo if needed
            );
            console.log("Inventory Transaction Data:", data);
            setLoading(false);
            setTableData(data.inventory || []); // Set the inventory array if it exists
            setTotalTransactionCount(data?.pagination?.totalCount);
            setError(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Error Fetching Data !");
            setLoading(false);
            setTableData([]); // Fallback to an empty array on error
            setError(true);
        }
    };

    const handleFilterOption = (option) => {
        setFilteredSelectedValue(option.TransactionType);
        setFilterSelectedTransactionId(option.key);
        console.log("Transaction Type:", option.TransactionType, "Transaction ID:", option.key);
        fetchData(productData.key, option.key); // Fetch data for selected filter
        setShowFilterOptions(false); // Close the filter dropdown after selection
    };

      const columns = [
        { field: "TransactionNo", headerName: "Transaction No" },
        { field: "TransactionDate", headerName: "Transaction Date",type:"date" },
        ...(filteredSelectedValue === "All" ? [{ field: "TransactionType", headerName: "Transaction Type" }] : []), // Add conditionally
        { field: "StoreName", headerName: "Store Name" },
        { field: "MRP", headerName: "MRP", type:"currency" },
        { field: "RetailPrice", headerName: "Retail Price", type:"currency" },
        { field: "Qty", headerName: "Qty", type:"number" },
        { field: "Brand", headerName: "Unit", type:"number"},
        { field: "SubTotal", headerName: "Subtotal", type:"currency" },
        { field: "DiscountAmount", headerName: "Discount",type:"number"},
        { field: "TaxGroup", headerName: "Tax" },
        { field: "TotalTax", headerName: "Tax Amount", type:"currency" },
        { field: "Amount", headerName: "Total", type:"currency" },
    ];
    

    // const rows = tableData.map((item) => {
    //     const date = new Date(item.TransactionDate);
    //     return {
    //         TransactionNo: item.TransactionNo || "N/A",
    //         TransactionDate: `${date.getDate()} ${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][date.getMonth()]} ${date.getFullYear()}` || "N/A",
    //         TransactionType:item.TransactionType,
    //         StoreName: item.StoreName || "N/A",
    //         MRP: item.MRP || "0",
    //         SupplyPrice: item.SupplyPrice || "0",
    //         Qty: item.Qty || "0",
    //         FreeQty: item.FreeQty || "0",
    //         TotalQty: item.TotalQty || "0",
    //         Unit: item.Unit || "0",
    //         SubTotal: item.SubTotal || "0",
    //         DiscountAmount: item.DiscountAmount || "0",
    //         Tax: item.Tax || "0",
    //         TotalTax: item.TotalTax || "0",
    //         Total: item.Total || "0",
    //     };
    // });

    // const displayedRows = rows.slice(
    //     (currentPage - 1) * rowsPerPage,
    //     currentPage * rowsPerPage
    // );

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setFrom((newPage - 1) * rowsPerPage);
    };

    const handleRowsPerPageChange = (newSize) => {
        setRowsPerPage(newSize);
        setSize(newSize);
        setCurrentPage(1); // Reset to first page
        setFrom(0); // Reset from to 0
    };

    return (
            <div className="h-full flex flex-col overflow-hidden pt-4">
            
                 <div className={`flex-grow ${isMobileView() && "pb-12"} overflow-hidden`}>
                      <div className="px-4 pt-3 mb-2">
                <div className="flex space-x-4">
                    <div className="relative">
                        <span className="block">
                            <button
                                onClick={() => setShowFilterOptions(!showFilterOptions)}
                                className="flex text-[#5e5e5e] items-center bg-[#F5F5F5] h-[34px] px-2 border-[#ddd] border-1 rounded-lg cursor-pointer hover:border-gray-400 hover:bg-[#f6f6f6] hover:text-[#000000] inline-block "
                                style={{ width: "auto" }}
                            >
                                Filtered By : <span className="text-[#000000]">{filteredSelectedValue}</span>
                                <span className="w-2.5 flex inline-block mb-0.5 ml-1">
                                    <Icon type="downarrownew" />
                                </span>
                            </button>

                            {/* Dropdown options */}
                            {showFilterOptions && (
                                <div
                                    className="absolute z-10 mt-1.5 rounded-lg shadow-lg bg-white  w-full"
                                    style={{
                                        top: "100%",
                                        left: 0,
                                        boxShadow: "0 2px 10px rgba(215, 213, 226, 0.5), 0 4px 6px rgba(0, 0, 0, 0.1)"
                                    }}
                                >
                                    {filterOptions.map((option, index) => (
                                        <div
                                            key={index}
                                            onClick={() => handleFilterOption(option)}
                                            className="hover:bg-[#6E2D90] hover:text-white px-2 py-2 cursor-pointer "
                                            style={{ width: "auto" }}
                                        >
                                            {option.TransactionType}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </span>
                    </div>
                </div>
            </div>
                <CustomTable
                    columns={columns}
                    loading={loading}
                    rows={tableData}
                    showTextOnRows={
                        tableData.length > 0
                            ? null
                            : "No data available"
                    }
                       allowMobilePagination={true}
            pagination={{
              currentPage,
              totalCount:totalTransactionCount,
              rowsPerPage,
              onPageChange: handlePageChange,
              loading
            }}

                />

            </div>
           {!isMobileView() && <div className="flex-none">
                 <Pagination
                  count={totalTransactionCount}
                    page={currentPage}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                />
             
            </div>}

        </div>
     
    );
};

export default ProductInventorytransaction;